/* ===========================================================
 * jquery.shuffle-images.js v1.0
 * ===========================================================
 * Copyright 2014 Pete Rojwongsuriya.
 * http://www.thepetedesign.com
 *
 * Shuffle Images let you display and shuffle multiple 
 * images by moving cursor around and many more ways to trigger.
 *
 * https://github.com/peachananr/shuffle-images
 * 
 * License: GPL v3
 *
 * ========================================================== */

!function($){
  
  var defaults = {
    trigger: "imageMouseMove",
    triggerTarget: false,
    mouseMoveTrigger: 50,
    hoverTrigger: 200,
    scrollTrigger: 100,
    target: "> img"
  };  
  
  
  $.fn.shuffleImages = function(options){
    return this.each(function(){
      var settings = $.extend({}, defaults, options),
          el = $(this),
          prevLoc = 0,
          mouseMoveTrigger = settings.mouseMoveTrigger,
          hoverTrigger = settings.hoverTrigger,
          scrollTrigger = settings.scrollTrigger,
          triggerTarget = settings.triggerTarget,
          $targets = el.find(settings.target);
      
      el.addClass("si-container")
      el.find("> img:first-child").addClass("active")
      
      if (el.attr("data-si-mousemove-trigger")) mouseMoveTrigger = el.data("si-mousemove-trigger");
      
      if (el.attr("data-si-hover-trigger")) hoverTrigger = el.data("si-hover-trigger");
      
      if (el.attr("data-si-scroll-trigger")) scrollTrigger = el.data("si-scroll-trigger");
      if (settings.triggerTarget == false) triggerTarget = el;
      
      triggerTarget.mousemove(function(event) {
        var posX = event.clientX - el[0].getBoundingClientRect().left;
        var index = Math.floor(posX / mouseMoveTrigger);

        el.find("img.active").removeClass("active");
        var $active = $targets.eq(index);
        $active.addClass("active");
      });

      triggerTarget.mouseout(function(event) {
        el.find("img.active").removeClass("active");
        var $active = $targets.eq(0);
        $active.addClass("active");
      });
      
    });
    
  }
  

}(window.jQuery);